import { useTranslation } from "react-i18next";
import * as Yup from "yup";

export function TypeModelsValidationSchema() {
  const { t } = useTranslation();

  const validation = Yup.object().shape({
    name: Yup.string().required(t("LABEL.required")),
    entity_type: Yup.string()
      .required(t("LABEL.required"))
      .oneOf(["patient", "employee", "both"]),
  });

  return validation;
}
